import { render, staticRenderFns } from "./AiOptimizeDialog.vue?vue&type=template&id=3a67741a&scoped=true"
import script from "./AiOptimizeDialog.vue?vue&type=script&lang=js"
export * from "./AiOptimizeDialog.vue?vue&type=script&lang=js"
import style0 from "./AiOptimizeDialog.vue?vue&type=style&index=0&id=3a67741a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a67741a",
  null
  
)

export default component.exports